// extracted by mini-css-extract-plugin
export default {"root":"oE0hbxPE","type-list":"yVTPeeCo","icon":"uHjW+EVT","type-details":"pqeDLiXv","size-normal":"s-3iz9rv","size-small":"a6upCmMI","loader":"TK0Iikn2"};